import { ReactElement } from 'react';

import { TestableComponentProps, Tooltip } from '@dreryk/react-components';

import { translationKeys } from './translations';

type BlockedAccountTooltipProps = TestableComponentProps & {
   readonly children: ReactElement;
   readonly disabled: boolean;
};

export const BlockedAccountTooltip = (props: BlockedAccountTooltipProps): JSX.Element => {
   return (
      <Tooltip content={translationKeys.accountPartiallyBlocked} disabled={props.disabled} testId={props.testId}>
         {props.children}
      </Tooltip>
   );
};
